import FormField from './formField.js';

export class LicenseApplicationForm {

  constructor({ formData } = {}) {
    this.reset(formData);
    this.publishing = false;
  }

  get published() { return this.data.published; }
  set published(published) { this.data.published = published; }

  get title() { return this.data.title; }
  set title(title) { this.data.title = title; }

  get description() { return this.data.description; }
  set description(description) { this.data.description = description; }

  get fields() {
    return this.data.customFields;
  }
  addField() {
    this.data.customFields.push(new FormField());
  }
  removeField(id) {
    this.data.customFields = this.data.customFields.filter(field => field.id !== id);
  }
  moveField(id, byHowMany, toIndex) {
    let index = null;
    this.data.customFields.forEach((field, i) => {
      if (field.id === id) {
        index = i;
      }
    });
    if (index !== null) {
      let field = this.data.customFields[index];
      this.data.customFields.splice(index, 1);
      let insertAt = typeof toIndex === 'number' ? toIndex : (index + byHowMany);
      if (insertAt < 0) {
        insertAt = this.data.customFields.length;
      } else if (insertAt > this.data.customFields.length) {
        insertAt = 0;
      }
      this.data.customFields.splice(insertAt, 0, field);
    }
  }

  reset(formData) {
    this.data = {
      published: false,
      title: 'STR License Application',
      description: '',
      customFields: [],
      useNewVersion: null,
      ...(formData || {})
    };
    if (this.data.useNewVersion === null) {
      this.data.useNewVersion = Boolean(this.data.survey);
    }
    this.data.customFields = this.data.customFields.map(field => {
      if (field instanceof FormField) return field;
      else return new FormField(field);
    });
  }

  serialize() {
    const data = { ...this.data };
    delete data.licenseApplicationForm;
    return {
      ...data,
      customFields: this.fields.map(field => field.serialize())
    };
  }

  get supportsCustomFields() {
    if (this.useNewVersion) {
      for (const page of (this.surveyJson?.pages || [])) {
        if (page.elements?.length > 0) {
          return true;
        }
      }
      return this.surveyJson?.elements?.length > 0;
    } else {
      return this.fields.length > 0;
    }
  }

  get useNewVersion() {
    return this.data.useNewVersion || false;
  }
  set useNewVersion(useNewVersion) {
    this.data.useNewVersion = useNewVersion;
  }

  get surveyJson() {
    if (this.data.survey) {
      return this.data.survey;
    } else {
      return {
        elements: this.fields.map(field => field.surveyJson)
      };
    }
  }

  set surveyJson(surveyJson) {
    this.data.survey = surveyJson;
  }
}
